import { ExternalLink } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useEvent } from '../Common/EventProvider';
import UI from '../../common/UI';
import useDocumentTitle from '../../common/useDocumentTitle';
import useLocale from '../../common/useLocale';

const PrivacyPage = () => {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const { event } = useEvent();
  const { project } = event;

  useDocumentTitle([t('common:privacy_statement.privacy_statement'), event.title]);

  return (
    <>
      {project.privacy_statement && (
        <>
          <UI.HR />
          <UI.Div>
            <UI.H3>
              {t('common:privacy_statement.privacy_statement')}
            </UI.H3>
            <UI.HTML html={project.privacy_statement} />
          </UI.Div>
        </>
      )}

      <UI.HR />

      <UI.Div>
        <UI.H3>
          {t('common:atleta')}
        </UI.H3>
        <UI.Paragraph>
          {t('common:privacy_statement.atleta_privacy_statement_intro', { organizer: project.organisation_name })}
        </UI.Paragraph>
        <UI.A
          href={`https://about.atleta.cc/${locale}/privacy?utm_source=Atleta`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('common:privacy_statement.read_atletas_privacy_statement')}
          {' '}
          <UI.Icon>
            <ExternalLink />
          </UI.Icon>
        </UI.A>
      </UI.Div>
    </>
  );
};

export default PrivacyPage;
